import React from "react";
import PropTypes from "prop-types";
import { AuthProvider } from "./AuthContext";
import { UsersProvider } from "./UsersContext";

/**
 * AppProviders component that combines all context providers
 * in the correct hierarchy.
 *
 * The order matters:
 * - AuthProvider (highest level, provides authentication)
 * - UsersProvider (depends on AuthProvider)
 */
const AppProviders = ({ children }) => {
  return (
    <AuthProvider>
      <UsersProvider>{children}</UsersProvider>
    </AuthProvider>
  );
};

AppProviders.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppProviders;
